"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.otherAllergyMessages = exports.foodAllergyMessages = exports.medicineSensitivityMessages = exports.OtherAllergy = exports.FoodAllergy = exports.MedicineSensitivity = void 0;
const schema_1 = require("../../../../../schema");
var MedicineSensitivity;
(function (MedicineSensitivity) {
    MedicineSensitivity["MEDICINE_SENSITIVITY_NO"] = "medicine_sensitivity_no";
    MedicineSensitivity["MEDICINE_SENSITIVITY_ACETHYLSALICILATE"] = "medicine_sensitivity_acethylsalicilate";
    MedicineSensitivity["MEDICINE_SENSITIVITY_AMLODIPINE"] = "medicine_sensitivity_amlodipine";
    MedicineSensitivity["MEDICINE_SENSITIVITY_BETA_RECEPTOR_ANTAGONISTS"] = "medicine_sensitivity_beta_receptor_antagonists";
    MedicineSensitivity["MEDICINE_SENSITIVITY_CEPHALOSPORINE"] = "medicine_sensitivity_cephalosporine";
    MedicineSensitivity["MEDICINE_SENSITIVITY_DIGITALIS"] = "medicine_sensitivity_digitalis";
    MedicineSensitivity["MEDICINE_SENSITIVITY_FLUOROCINOLONE"] = "medicine_sensitivity_fluorocinolone";
    MedicineSensitivity["MEDICINE_SENSITIVITY_NSAID"] = "medicine_sensitivity_NSAID";
    MedicineSensitivity["MEDICINE_SENSITIVITY_PENICILLIN"] = "medicine_sensitivity_penicillin";
    MedicineSensitivity["MEDICINE_SENSITIVITY_RASI"] = "medicine_sensitivity_RASI";
    MedicineSensitivity["MEDICINE_SENSITIVITY_SULFAMETAXASOLE_THROMETOPRIM"] = "medicine_sensitivity_sulfametaxasole_thrometoprim";
    MedicineSensitivity["MEDICINE_SENSITIVITY_VANCOMYCIN"] = "medicine_sensitivity_vancomycin";
    MedicineSensitivity["MEDICINE_SENSITIVITY_OTHER"] = "medicine_sensitivity_other";
})(MedicineSensitivity || (exports.MedicineSensitivity = MedicineSensitivity = {}));
var FoodAllergy;
(function (FoodAllergy) {
    FoodAllergy["FOOD_ALLERGY_NO"] = "food_allergy_no";
    FoodAllergy["FOOD_ALLERGY_GLUTEN"] = "food_allergy_gluten";
    FoodAllergy["FOOD_ALLERGY_LACTOSE"] = "food_allergy_lactose";
    FoodAllergy["FOOD_ALLERGY_OTHER"] = "food_allergy_other";
})(FoodAllergy || (exports.FoodAllergy = FoodAllergy = {}));
var OtherAllergy;
(function (OtherAllergy) {
    OtherAllergy["ALLERGY_LATEX"] = "allergy_latex";
})(OtherAllergy || (exports.OtherAllergy = OtherAllergy = {}));
exports.medicineSensitivityMessages = {
    [MedicineSensitivity.MEDICINE_SENSITIVITY_NO]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_NO",
        defaultMessage: "Nincs vagy nem ismert"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_ACETHYLSALICILATE]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_ACETHYLSALICILATE",
        defaultMessage: "Acethylsalicilate"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_AMLODIPINE]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_AMLODIPINE",
        defaultMessage: "Amlodipine"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_BETA_RECEPTOR_ANTAGONISTS]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_BETA_RECEPTOR_ANTAGONISTS",
        defaultMessage: "ß blokkoló"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_CEPHALOSPORINE]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_CEPHALOSPORINE",
        defaultMessage: "Cephalosporin"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_DIGITALIS]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_DIGITALIS",
        defaultMessage: "Digitalis"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_FLUOROCINOLONE]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_FLUOROCINOLONE",
        defaultMessage: "Fluorokinolon"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_NSAID]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_NSAID",
        defaultMessage: "NSAID"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_PENICILLIN]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_PENICILLIN",
        defaultMessage: "Penicillin"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_RASI]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_RASI",
        defaultMessage: "RASI"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_SULFAMETAXASOLE_THROMETOPRIM]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_SULFAMETAXASOLE_THROMETOPRIM",
        defaultMessage: "Sulfametaxasole / Thrometoprim"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_VANCOMYCIN]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_VANCOMYCIN",
        defaultMessage: "Vancomycin"
    },
    [MedicineSensitivity.MEDICINE_SENSITIVITY_OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.medicineSensitivity.MEDICINE_SENSITIVITY_OTHER",
        defaultMessage: "Egyéb gyógyszerérzékenység"
    }
};
exports.foodAllergyMessages = {
    [FoodAllergy.FOOD_ALLERGY_NO]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.foodAllergy.FOOD_ALLERGY_NO",
        defaultMessage: "Nincs vagy nem ismert"
    },
    [FoodAllergy.FOOD_ALLERGY_GLUTEN]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.foodAllergy.FOOD_ALLERGY_GLUTEN",
        defaultMessage: "Glutén"
    },
    [FoodAllergy.FOOD_ALLERGY_LACTOSE]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.foodAllergy.FOOD_ALLERGY_LACTOSE",
        defaultMessage: "Laktóz"
    },
    [FoodAllergy.FOOD_ALLERGY_OTHER]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.foodAllergy.FOOD_ALLERGY_OTHER",
        defaultMessage: "Egyéb étel allergia"
    }
};
exports.otherAllergyMessages = {
    [OtherAllergy.ALLERGY_LATEX]: {
        id: "ktx.transplantationScreening.medicalHistory.risks.allergiesAndSensitivities.otherAllergy.ALLERGY_LATEX",
        defaultMessage: "Latex allergia"
    }
};
const medicineSensitivity = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_NO)
        .interpretation({ vocab: "ktx", code: "medicine_sensitivity_no" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_ACETHYLSALICILATE)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_acethylsalicilate"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_AMLODIPINE)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_amlodipine"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_BETA_RECEPTOR_ANTAGONISTS)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_beta_receptor_antagonists"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_CEPHALOSPORINE)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_cephalosporine"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_DIGITALIS)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_digitalis"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_FLUOROCINOLONE)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_fluorocinolone"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_NSAID)
        .interpretation({ vocab: "ktx", code: "medicine_sensitivity_NSAID" })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_PENICILLIN)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_penicillin"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_RASI)
        .interpretation({ vocab: "ktx", code: "medicine_sensitivity_RASI" })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_SULFAMETAXASOLE_THROMETOPRIM)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_sulfametaxasole_thrometoprim"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_VANCOMYCIN)
        .interpretation({
        vocab: "ktx",
        code: "medicine_sensitivity_vancomycin"
    })
        .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
        .tag({ vocab: "ktx", code: "medicine_sensitivity" }),
    schema_1.Schema.multiChoiceItem(MedicineSensitivity.MEDICINE_SENSITIVITY_OTHER)
]);
const medicineSensitivityOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../medicineSensitivity}) && ({../medicineSensitivity}).includes("medicine_sensitivity_other")`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "ktx", code: "medicine_sensitivity_other" })
    .tag({ vocab: "ktx", code: "medicine_active_ingredient" })
    .tag({ vocab: "fyrms", code: "unstructured_field" })
    .tag({ vocab: "ktx", code: "medicine_sensitivity" }));
const foodAllergy = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(FoodAllergy.FOOD_ALLERGY_NO)
        .interpretation({ vocab: "ktx", code: "food_allergy_no" })
        .tag({ vocab: "ktx", code: "food_allergy" })
        .tag({ vocab: "snomed", code: "414285001", source: "synonym" }),
    schema_1.Schema.multiChoiceItem(FoodAllergy.FOOD_ALLERGY_GLUTEN)
        .interpretation({ vocab: "ktx", code: "food_allergy_gluten" })
        .tag({ vocab: "ktx", code: "food_allergy" })
        .tag({ vocab: "snomed", code: "414285001", source: "synonym" }),
    schema_1.Schema.multiChoiceItem(FoodAllergy.FOOD_ALLERGY_LACTOSE)
        .interpretation({ vocab: "ktx", code: "food_allergy_lactose" })
        .tag({ vocab: "ktx", code: "food_allergy" })
        .tag({ vocab: "snomed", code: "414285001", source: "synonym" }),
    schema_1.Schema.multiChoiceItem(FoodAllergy.FOOD_ALLERGY_OTHER)
]);
const foodAllergyOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../foodAllergy}) && ({../foodAllergy}).includes("food_allergy_other")`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({ vocab: "ktx", code: "food_allergy_other" })
    .tag({ vocab: "fyrms", code: "unstructured_field" })
    .tag({ vocab: "ktx", code: "food_allergy" })
    .tag({ vocab: "snomed", code: "414285001", source: "synonym" }));
const otherAllergy = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(OtherAllergy.ALLERGY_LATEX)
        .interpretation({ vocab: "ktx", code: "allergy_latex" })
        .tag({ vocab: "ktx", code: "other_allergy" })
]).optional();
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    medicineSensitivity,
    medicineSensitivityOther,
    foodAllergy,
    foodAllergyOther,
    otherAllergy
})
    .interpretation({
    vocab: "ktx",
    code: "sensitivities_and_allergies_statement"
})
    .tag({ vocab: "fyrms", code: "action" });
